export default "__VITE_ASSET__0d9588ab__"